import React from 'react';
import { useLocation } from 'react-router-dom';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import './footer.scss';

const SCROLL_DURATION_MS = 450;

const easeInOutCubic = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

// ScrollView's scrollTo/scrollToElement jump instantly, so animate by calling
// the public scrollTo() each frame. Honours the OS "reduce motion" setting.
function smoothScrollTo(scrollView, targetTop) {
  const element = scrollView.element();
  const maxTop = Math.max(0, scrollView.scrollHeight() - element.clientHeight);
  const endTop = Math.min(Math.max(0, targetTop), maxTop);
  const startTop = scrollView.scrollTop();
  const distance = endTop - startTop;

  if (distance === 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    scrollView.scrollTo(endTop);
    return;
  }

  // A new click restarts the animation from wherever the previous one got to.
  cancelAnimationFrame(scrollView.footerScrollFrame);
  const startTime = performance.now();
  const step = now => {
    const progress = Math.min(1, (now - startTime) / SCROLL_DURATION_MS);
    scrollView.scrollTo(startTop + distance * easeInOutCubic(progress));
    if (progress < 1) {
      scrollView.footerScrollFrame = requestAnimationFrame(step);
    }
  };
  scrollView.footerScrollFrame = requestAnimationFrame(step);
}

export default ({ scrollViewRef }) => {
  const editProfilePath = "/edit-profile";

  const { pathname } = useLocation();

  // Sections are found by the form items' cssClass (see edit-profile.jsx), not
  // by item index, so adding or hiding form items can't break the navigation.
  function scrollToSection(cssClass) {
    const scrollView = scrollViewRef?.current?.instance();
    const section = document.querySelector(`.${cssClass}`);
    if (!scrollView || !section) {
      return;
    }
    const offset = section.getBoundingClientRect().top - scrollView.element().getBoundingClientRect().top;
    smoothScrollTo(scrollView, scrollView.scrollTop() + offset);
  }

  return (
    (pathname && pathname.includes(editProfilePath)) &&
    <footer className='footer-component'>
      <Toolbar id='footer'>
        <Item
            location="before"
        >
            <Button
              hint="Personal Information"
              icon="fa-solid fa-person"
              onClick={() => {
                const scrollView = scrollViewRef?.current?.instance();
                scrollView && smoothScrollTo(scrollView, 0);
              }}
            />
        </Item>
        <Item
          location="before"
        >
            <Button
              icon="fa-solid fa-envelope"
              hint="Contact Information"
              onClick={() => {
                scrollToSection('contact_information');
              }}
            />
        </Item>
        <Item
          location="before"
        >
            <Button
              hint="Work Locations"
              icon="fa-solid fa-location-dot"
              onClick={() => {
                scrollToSection('school_associations');
              }}
            />
        </Item>
        <Item
          location="before"
        >
            <Button
              icon="fa-solid fa-trophy"
              hint="Designations"
              onClick={() => {
                scrollToSection('designations');
              }}
            />
        </Item>
      </Toolbar>
      </footer>
  )
};
